export class User{
	ident: string;
	lastname: string;
	name: string;
	birth: string;
	img?: string;
	imgFile?: File;
	email: string;
	isNewsLetter: boolean=false;
	pass?: string;
	web?: string;
	tel?: string;
	address: string;
	cp: string;
	city: string;
	country: number;
	dateCreate: Date;
	rights: string[]=[];
	rmImg?: boolean;
}

export class Pays{
	id: number;
	name: string;
	prefixe: string;
	codeIso: string;
}

export class Right{
	name: string;
    libelle: string;
}

export class Plan{
	user: string;
	start: string;
	end: string;
}